import src from "IMAGE";
export default { src, width: 582, height: 629, blurWidth: 0, blurHeight: 0};
